import React, { useEffect } from 'react'
import style from './style.module.sass'
import { Nav, NavItem, NavLink, TabContent, TabPane } from 'reactstrap'
import FolderSelectionTable from './FolderSelectionTable'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import { useActions } from '../../../utils/action-helper'
import {
  dashboardGetFoldersByFilter,
  dashboardSetFilter,
  dashboardSetFolderSelected,
  dashboardSetFolderType,
  dashboardSetOpenedFolders
} from '../../../actions'
import { deepCopy } from '../../../utils'
import TLServiceComponent from '../../../contexts/TLServiceComponent'
import { useTheme } from '@material-ui/styles'
import config from '../../../config'

export default function DashFilterHeader ({ panel }) {
  const { t } = useTranslation()
  const tlService = React.useContext(TLServiceComponent)
  const { theme: { bgColors, colors } } = useTheme()
  const themeState = useSelector(state => state.userData.theme || localStorage.getItem('theme') || config.THEMES_MODES.LIGHT)
  const isDark = themeState === config.THEMES_MODES.CONTRAST_DARK
  const activeColor = isDark ? colors.colorTextReverse : colors.colorText
  const {
    aDashboardSetOpenedFolders,
    aDashboardSetFolderSelected,
    aDashboardSetFolderType,
    aDashboardSetFilter,
    aDashboardGetFoldersByFilter
  } = useActions({
    aDashboardSetFolderType: dashboardSetFolderType,
    aDashboardSetFilter: dashboardSetFilter,
    aDashboardSetFolderSelected: dashboardSetFolderSelected,
    aDashboardSetOpenedFolders: dashboardSetOpenedFolders,
    aDashboardGetFoldersByFilter: dashboardGetFoldersByFilter(tlService)
  })

  const token = useSelector(state => state.userData.token)
  const filter = useSelector(state => state.dashboardData.filter[panel])
  const activeTab = useSelector(state => state.dashboardData.folderType[panel])
  const userId = useSelector(state => state.userData.user.id)
  const userGroup = useSelector(state => state.userData.user.user_group_id)
  const userCompany = useSelector(state => state.userData.user.company_id)

  const toggle = tab => {
    aDashboardSetFolderType(panel, tab)
  }

  useEffect(() => {
    let folderFilter
    if (activeTab === 'personal')
      folderFilter = { user_id: userId }
    else if (activeTab === 'group')
      folderFilter = { user_group_id: userGroup }
    else if (activeTab === 'company')
      folderFilter = { company_id: userCompany }
    // clear select
    aDashboardSetFolderSelected(panel, [])
    aDashboardSetOpenedFolders(panel, [])
    // get folders
    aDashboardGetFoldersByFilter(token, panel, folderFilter)
    // update main filter
    let mainFilter = deepCopy(filter)
    delete mainFilter['user_id']
    delete mainFilter['user_group_id']
    delete mainFilter['company_id']
    aDashboardSetFilter(panel, { ...mainFilter, ...folderFilter })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activeTab])

  return (
    <>
      <div className={`${style.tableWrapper__head} d-flex align-items-center`} style={{ backgroundColor: bgColors.bgPrimary600, color: colors.colorContrast }}>
        <h5 className={`m-0 mr-auto`}>{t('Filters')}&nbsp;</h5>
      </div>
      <div className={`w-100 p-0 ${style.selectionModal}`} style={{ backgroundColor: bgColors.bgPrimary100 }}>
        <div className={`${style.tabs}`} style={{ backgroundColor: bgColors.bgPrimary300 }}>
          <Nav tabs>
            <NavItem>
              <NavLink
                className={activeTab === 'personal' ? 'active' : ''}
                onClick={() => {
                  toggle('personal')
                }}
              style={{ color: activeTab === 'personal' ? activeColor : colors.colorText}}
              >{t('Personal archive')}</NavLink>
            </NavItem>
            <NavItem>
              <NavLink
                className={activeTab === 'group' ? 'active' : ''}
                onClick={() => {
                  toggle('group')
                }} style={{ color: activeTab === 'group' ? activeColor : colors.colorText}}
              >{t('Group archive')}</NavLink>
            </NavItem>
            <NavItem>
              <NavLink
                className={activeTab === 'company' ? 'active' : ''}
                onClick={() => {
                  toggle('company')
                }} style={{ color: activeTab === 'company' ? activeColor : colors.colorText}}
              >{t('Company archive')}</NavLink>
            </NavItem>
          </Nav>
          <TabContent activeTab={activeTab}>
            <TabPane tabId="personal">
              {activeTab === 'personal' && <FolderSelectionTable panel={panel}/>}
            </TabPane>
            <TabPane tabId="group">
              {activeTab === 'group' && <FolderSelectionTable panel={panel}/>}
            </TabPane>
            <TabPane tabId="company">
              {activeTab === 'company' && <FolderSelectionTable panel={panel}/>}
            </TabPane>
          </TabContent>
        </div>
      </div>
    </>
  )
}